import { render } from "./Pages.vue?vue&type=template&id=ffc0ec70&scoped=true"
import script from "./Pages.vue?vue&type=script&lang=js"
export * from "./Pages.vue?vue&type=script&lang=js"

import "./Pages.vue?vue&type=style&index=0&id=ffc0ec70&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ffc0ec70"

export default script